if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let signupState = document.querySelector('#email-signup_state');
    if(signupState){
        let option = document.createElement('option');
        option.text = 'Outside the U.S';
        option.value = 'Outside the U.S';
        option.dataset.key = 'Outside the U.S';

        console.log(signupState.firstChild.nextSibling);

        signupState.insertBefore(option, signupState.firstChild.nextSibling.nextSibling);
    }

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    // slick default setting
	let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 4000,disableOnInteraction: false}};

	// start slider default
	document.querySelectorAll('.swiper-js').forEach((element,i) => {
		
		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper): defaulsettings;
		
		element.setAttribute(`data-swiper-${i}`,"")
		
		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        
        if (swiper.passedParams.goto) {
            const hovernav = document.querySelectorAll(`${swiper.passedParams.goto.mouseitem}`);
            hovernav.forEach(element => {
                ["mouseover","touchend"].forEach(currentevent => {
                    element.addEventListener(currentevent, (event) => {
                        document.querySelectorAll(`${swiper.passedParams.goto.mouseitem}`).forEach(element => {element.classList.remove("active")});
                        event.currentTarget.classList.add("active");
                        swiper.slideTo(event.currentTarget.dataset.go);
                    });
                });
            });
        }

		
	});

    //accordion Funcionality
	let acordionitems = document.querySelectorAll(".accordion-js h2");
	acordionitems.forEach((item) => {
		item.addEventListener("click", (element) => {

			if (!element.target.classList.contains("active")) {
				element.target.classList.add("active");
				element.target.nextElementSibling.classList.add("active");
			} else {
				element.target.classList.remove("active");
				element.target.nextElementSibling.classList.remove("active");
			}

		});
	});
    
    // table section
    const tablesResp = document.querySelectorAll('.capacity-chart__table table');
    if (tablesResp.length) {
        tablesResp.forEach((tablei) => {
            let tableresponsive = document.createElement('div')
            tableresponsive.classList.add('tableHold')
            tablei.parentNode.insertBefore(tableresponsive, tablei)
            tableresponsive.append(tablei)
            const ths = tablei.querySelectorAll('tr:first-child > *')
            tablei.querySelectorAll('tr + tr').forEach((row) => {
                const tds = row.querySelectorAll('td')
                let i = 0
                for (i; i < tds.length; i++) {
                    tds[i].setAttribute('data-label', ths[i].textContent)
                }
            })
            const rowHeads = tablei.querySelectorAll('tr td:first-child')
            rowHeads.forEach((ele) => {
                ele.addEventListener('click', (ev) => {
                    ele.closest('tr').classList.toggle('active')
                })
            })
        })
    }
    
    // section with tag
    tagsection(".specialtab-js",".tabs-special__item ",".specialselect-js")
    

})();

/** ADA Mobile Menu Navigation **/
document.addEventListener("DOMContentLoaded", () => {
    const mobileNav = document.querySelector("#mobile-nav-js");

    if (mobileNav) {
        const navLinks = mobileNav.querySelectorAll("a");

        navLinks.forEach(link => {
            link.setAttribute("tabindex", "-1");
        });
    }
});
